import { useState } from 'react';
import { categories } from '@/mocks/categories';

export default function CategoryDropdown() {
  const [selected, setSelected] = useState('');

  const handleChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const url = e.target.value;
    if (url) {
      setSelected(url);
      window.open(url, '_blank', 'noopener,noreferrer');
      setSelected('');
    }
  };

  return (
    <section className="w-full py-12 md:py-16 px-4 md:px-6 bg-background-100">
      <div className="max-w-3xl mx-auto text-center">
        <h2 className="font-heading text-2xl md:text-3xl font-semibold text-foreground-900 mb-4">
          Kategorien durchsuchen
        </h2>
        <p className="text-foreground-600 mb-8 max-w-xl mx-auto">
          W&auml;hle eine Kategorie aus und entdecke die besten Produkte auf unserem Oopbuy Spreadsheet
        </p>

        <div className="relative max-w-md mx-auto">
          <select
            value={selected}
            onChange={handleChange}
            className="w-full appearance-none bg-background-50 border-2 border-background-300 rounded-full px-6 py-4 text-foreground-800 font-medium cursor-pointer hover:border-primary-400 focus:border-primary-500 focus:outline-none transition-colors duration-200 text-base"
          >
            <option value="">-- Kategorie ausw&auml;hlen --</option>
            {categories.map((cat) => (
              <option key={cat.id} value={cat.url}>
                {cat.name}
              </option>
            ))}
          </select>
          <div className="absolute right-5 top-1/2 -translate-y-1/2 pointer-events-none">
            <i className="ri-arrow-down-s-line w-5 h-5 flex items-center justify-center text-foreground-500"></i>
          </div>
        </div>
      </div>
    </section>
  );
}